<script lang="ts">
  import DriverCard from './DriverCard.svelte';
  import type { Driver } from '../types';

  interface Props {
    drivers: Record<string, Driver>;
    searchTerm: string;
    selectedDriverId: string | null;
    onSearch: (term: string) => void;
    onSelectDriver: (driverId: string) => void;
    onRouteView?: (driverId: string, route: any[]) => void;
    /** Map driver_id -> nonce que se incrementa por delivery_status_changed. */
    driverRefreshNonces?: Record<string, number>;
  }

  let { drivers, searchTerm, selectedDriverId, onSearch, onSelectDriver, onRouteView, driverRefreshNonces = {} }: Props = $props();
  let displayedConnected = $state(50);
  let displayedDisconnected = $state(50);

  let connectedDrivers = $derived(
    Object.entries(drivers).filter(([_, driver]) => driver.connected)
  );

  let disconnectedDrivers = $derived(
    Object.entries(drivers).filter(([_, driver]) => !driver.connected)
  );

  function handleSearchInput(e: Event) {
    const target = e.target as HTMLInputElement;
    onSearch(target.value);
  }

  function loadMoreConnected() {
    displayedConnected += 50;
  }

  function loadMoreDisconnected() {
    displayedDisconnected += 50;
  }
</script>

<div class="w-96 flex flex-col bg-white/5 border border-white/10 rounded-2xl overflow-hidden min-w-0 min-h-0">
  <div class="p-4 border-b border-white/10 flex-shrink-0">
    <h2 class="font-bold text-lg text-white mb-3">
      👥 Conductores ({Object.keys(drivers).length})
    </h2>
    <input
      type="text"
      placeholder="🔍 Buscar por conductor o OT..."
      value={searchTerm}
      onkeyup={handleSearchInput}
      class="w-full px-3 py-2 bg-white/10 border border-white/20 rounded-lg text-xs text-white placeholder-gray-500 focus:outline-none focus:border-[#FFFF00]"
    />
  </div>

  <div class="flex-1 overflow-y-auto flex flex-col gap-2 p-4 min-h-0">
    <!-- Connected Section -->
    <div class="px-3 py-2 bg-green-500/20 border-l-4 border-green-500 text-green-400 font-bold text-sm mb-2">
      🟢 CONECTADOS ({connectedDrivers.length})
    </div>

    {#if connectedDrivers.length > 0}
      {#each connectedDrivers.slice(0, displayedConnected) as [driver_id, driver] (driver_id)}
        <DriverCard
          {driver_id}
          {driver}
          isSelected={selectedDriverId === driver_id}
          onSelect={onSelectDriver}
          {onRouteView}
          refreshNonce={driverRefreshNonces[driver_id] || 0}
        />
      {/each}

      {#if connectedDrivers.length > displayedConnected}
        <button
          type="button"
          onclick={loadMoreConnected}
          class="w-full px-3 py-2 bg-green-500/20 hover:bg-green-500/30 text-green-400 text-xs font-bold rounded mb-2 transition"
        >
          📥 Cargar {connectedDrivers.length - displayedConnected} más conectados
        </button>
      {/if}
    {:else}
      <div class="px-3 py-2 text-center text-gray-500 text-xs">Sin conductores conectados</div>
    {/if}

    <!-- Disconnected Section -->
    <div class="px-3 py-2 bg-gray-500/20 border-l-4 border-gray-500 text-gray-400 font-bold text-sm mb-2 mt-4">
      🔴 DESCONECTADOS ({disconnectedDrivers.length})
    </div>

    {#if disconnectedDrivers.length > 0}
      {#each disconnectedDrivers.slice(0, displayedDisconnected) as [driver_id, driver] (driver_id)}
        <DriverCard
          {driver_id}
          {driver}
          isSelected={selectedDriverId === driver_id}
          onSelect={onSelectDriver}
          {onRouteView}
          refreshNonce={driverRefreshNonces[driver_id] || 0}
        />
      {/each}

      {#if disconnectedDrivers.length > displayedDisconnected}
        <button
          type="button"
          onclick={loadMoreDisconnected}
          class="w-full px-3 py-2 bg-gray-500/20 hover:bg-gray-500/30 text-gray-400 text-xs font-bold rounded mb-2 transition"
        >
          📥 Cargar {disconnectedDrivers.length - displayedDisconnected} más desconectados
        </button>
      {/if}
    {:else}
      <div class="px-3 py-2 text-center text-gray-500 text-xs">Sin conductores desconectados</div>
    {/if}
  </div>
</div>
